<template>
  <div id="header" style="margin-bottom: -1px;">

    <high-importance-notifications></high-importance-notifications>

    <el-menu mode="horizontal" :default-active="'/'" background-color="#263238" text-color="#fff">
      <el-menu-item :index="''">
        <img :src="logo" height="35" class="custom-logo" />
      </el-menu-item>

      <el-menu-item :index="''" v-if="back_url">
        <el-button icon="fal fa-arrow-left" size="mini" type="info">
          <a :href="back_url"> {{ $t('topbar.back_button') }}</a>
        </el-button>
      </el-menu-item>


      <div style="text-align: right; height: 60px; padding-top: 15px; padding-right: 25px; color: #ffffff;">

        <span id="notifications_container" :style="{ marginRight: '20px' }">&nbsp;</span>

        <template v-if="isAdmin">
          <admin-account-selector :active_account="active_account" />
        </template>
        <template v-else>
          <account-selector :active_account="active_account"></account-selector>
        </template>


        <!--span v-if="show_menu">
            <el-tooltip
                class="item"
                effect="dark"
                :content="$t('browser_warning') + 'Chrome'"
                placement="bottom"
                v-if="alert.show"
            >
                <span class="clickable" @click="" style="margin-right: 25px;">
                    <i style="color: greenyellow;" class="fal fa-exclamation-triangle"></i>
                </span>
            </el-tooltip-->

        <!--el-tooltip v-if="!displayNotificationBar()" class="item" effect="dark" :content="$t('topbar.notifications')" placement="bottom">
            <el-badge :value="3" class="item">
                <span class="clickable">
                    <i class="far fa-bell"></i>
                </span>
            </el-badge>
        </el-tooltip-->
        <el-tooltip class="item" effect="dark" :content="$t('topbar.history')" placement="bottom">
          <span class="clickable" @click="loadHistory" style="margin-left: 25px; cursor: pointer;">
            <i class="fal fa-archive"></i>
          </span>
        </el-tooltip>

        <el-tooltip v-if="showPrintBasket" class="item" effect="dark" :content="$t('topbar.print_basket') || 'Print Basket'" placement="bottom">
          <el-badge :value="print_basket_count" :hidden="!print_basket_count" class="item">
            <span class="clickable" @click="togglePrintBasket" style="margin-left: 25px;">
              <i class="fal fa-shopping-basket"></i>
            </span>
          </el-badge>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" :content="$t('topbar.support')" placement="bottom">
          <span class="clickable" @click="loadSupport" style="margin-left: 25px; margin-right: 25px;">
            <i class="fal fa-question"></i>
          </span>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" :content="$t('topbar.profile')" placement="bottom">
          <span class="clickable" @click="loadSettings" style="margin-right: 25px;">
            <i class="fal fa-user"></i>
          </span>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" :content="$t('topbar.log_out')" placement="bottom">
          <span class="clickable" @click="confirmLogOut()">
            <i class="fal fa-power-off"></i>
          </span>
        </el-tooltip>

        <!--el-tooltip class="item" effect="dark" :content="$t('topbar.profile')" placement="bottom">
            <el-button icon="fal fa-user fa-lg" size="mini" type="primary" @click="loadSettings"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="$t('topbar.log_out')" placement="bottom">
            <el-button icon="fal fa-power-off fa-lg" size="mini" type="danger"
                       @click="confirmLogOut()"></el-button>
        </el-tooltip-->
      </div>
    </el-menu>

    <notification-bar :customer_id="getCustomerId"></notification-bar>

    <print-basket-modal
        v-if="showPrintBasket"
        :show.sync="show_print_basket"
        @basket-updated="onBasketDrawerUpdated"
    ></print-basket-modal>

  </div>
</template>

<script>
import AccountSelector from './components/AccountSelector';
import AdminAccountSelector from './components/AdminAccountSelector';
import NotificationBar from './components/NotificationBar';
import HighImportanceNotifications from "./components/HighImportanceNotifications";
import PrintBasketModal from "./components/PrintBasketModal";
import { isSettingEnabled, PRINT_BASKET_SETTING } from "../common/Settings";
import _ from 'lodash';
import AppLoader from '../bootstrap/app-loader'
import Axios from "axios";

export default {
  name: 'bs-wrapper',

  data() {
    return {
      collapsed: false,
      logo: null,
      back_url: null,
      isAdmin: false,
      idle_message: '',
      customers: [],
      login_url: process.env.VUE_APP_LOGIN_URL,


      apps: window.brandsafe_app_config.apps,
      show_menu: false,
      alert: {
        type: '',
        show: false,
        title: '',
        description: ''
      },
      web_socket_server: process.env.VUE_APP_WEBSOCKET_URL,
      connection: null,
      active_account: JSON.parse(localStorage.getItem('active_account')),
      print_basket_count: 0,
      show_print_basket: false,
      print_basket_enabled: false,
      cleanup_cookies: [
        'bs_token',
        'bs_token_valid_until',
        'bs_customer_id',
        'bs_departments',
        'bs_language',
        'bs_name',
        'bs_profile',
        'bs_role',
        'bs_user_id',
        'bs_username',
        'bs_active_department_id',
        'bs_notifications_popup_show'
      ]
    };
  },

  created() {
    let self = this;

    this.show_menu = this.showMenu();

    this.logo = this.getLogo();
    this.back_url = this.getBackUrl();
    this.checkSuperAdmin();
    this.loadPrintBasketSetting();

    window.addEventListener('print-basket-updated', this.onPrintBasketEvent);


    this.checkBrowser();

    // load the sub apps which are not part of navigation like app-notifications module
    AppLoader.loadSubApp('app-notifications')

    // this.checkForCookies();

    // this.handleWebSockets();

    // set app height

    setTimeout(() => {

      const header = document.getElementById('header');

      if (_.isObject(header)) {
        document.getElementById('front-app-container').style.height = (window.innerHeight - header.offsetHeight) + 'px';
      }
    }, 300);


  },

  computed: {
    // messageStr() {
    //     return this.isAppIdle ? this.stayLoggedIn() : 'hello';
    // }

    getCustomerId() {

      if (this.active_account == null) {
        return null;
      }

      if (!this.active_account.hasOwnProperty('customer') || !this.active_account.customer.hasOwnProperty('id')) {
        return null;
      }

      return this.active_account.customer.id;
    },

    showPrintBasket() {
      return this.print_basket_enabled;
    }

  },

  watch: {

    // 'isAppIdle'() {
    //     if (this.isAppIdle) {
    //         this.stayLoggedIn();
    //     }
    // }
  },

  mounted() {

  },

  methods: {

    isApoteket() {
      const customerId = this.$cookies.get('bs_customer_id');
      return ['47', '48'].includes(customerId);
    },

    // checkForCookies() {
    //     if (!this.$cookies.isKey("bs_active_department_id") || !this.$cookies.isKey("bs_customer_id") || !this.$cookies.isKey("bs_user_id")) {
    //         this.logOut(false, true);
    //     }
    // },

    /**handleWebSockets() {
                this.connection = new WebSocket(
                    this.web_socket_server + '?type=client' + '&token=' + this.$cookies.get('bs_token') + '&socket_uuid=' + localStorage.getItem('socket_uuid')
                );

                this.connection.onopen = () => {
                    this.connection.send('Handshake from: ' + this.$cookies.get('bs_name'));
                };

                this.connection.onerror = (error) => {
                    console.log('Woops, could not connect to socket server: ', error);
                };

                this.connection.onmessage = (message) => {
                    if (message.data.startsWith('handshake')) {
                        let msg = message.data.split(' ');
                        
                        let socket_uuid = msg[1];

                        localStorage.setItem('socket_uuid', socket_uuid);
                    }

                    else {
                        console.log(JSON.parse(message.data));
                    }
                };
            },**/

    checkBrowser() {
      // Opera 8.0+
      var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== 'undefined';

      // Safari 3.0+ "[object HTMLElementConstructor]"
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/false || !!document.documentMode;

      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;

      // Chrome 1 - 71
      var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
      //Chrome fallback > 71
      var ua = navigator.userAgent;

      if (ua.indexOf("Chrome") != -1) {
        isChrome = true;
      }

      // Blink engine detection
      var isBlink = (isChrome || isOpera) && !!window.CSS;

      if (isChrome || isFirefox || isSafari || isEdge) {
        return false;
      } else {
        this.alert.type = 'warning';
        this.alert.title = this.$t('warning')
        this.alert.description = this.$t('browser_warning') + 'Chrome';
        this.alert.show = true;
      }
    },

    loadSettings() {
      window.location.href = window.location.origin + '/settings'
    },

    loadSupport() {
      window.location.href = window.location.origin + '/settings#/about'
    },


    loadHistory() {
      window.location.href = window.location.origin + '/analytics#/history'
    },

    getLogo() {
      let url_string = window.location.href;

      let url = new URL(url_string);

      let logo = url.searchParams.get('logo');

      if (logo) {
        localStorage.setItem('logo', logo);
        return logo;
      }

      logo = localStorage.getItem('logo');

      if (logo) {
        return logo;
      }

      return 'https://modules.brandsafe.no/assets/images/brandsafe-white.png';
    },

    // stayLoggedIn() {
    //     this.$confirm(this.$t('inactive_message'), this.$t('wops'),
    //         {
    //             confirmButtonText: this.$t('yes'),
    //             cancelButtonText: this.$t('no'),
    //             type: 'warning'
    //         }).then(() => {
    //         this.$message({
    //             type: 'success',
    //             message: this.$t('still_logged_in')
    //         });
    //     }).catch(() => {
    //         this.$message({
    //             type: 'info',
    //             message: this.$t('logging_out')
    //         });

    //         this.logOut(false);
    //     });
    // },

    getBackUrl() {
      let url_string = window.location.href;

      let url = new URL(url_string);

      let back_url = url.searchParams.get('backUrl');

      if (back_url !== null) {
        localStorage.setItem('back_url', back_url);
      }

      return localStorage.getItem('back_url');
    },

    confirmLogOut() {
      this.$confirm(this.$t('log_out_confirm'), this.$t('wops'),
        {
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no'),
          type: 'warning'
        }).then(() => {

          localStorage.removeItem('logo');

          this.$message({
            type: 'success',
            message: this.$t('logging_out')
          });

          this.logOut(false);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('logout_aborted')
          });
        });
    },

    checkSuperAdmin() {
      try {
        Axios.get(
          `https://api.brandsafe.no/v1/config/admin/check-super-admin/${this.$cookies.get('bs_user_id')}`,
          {
            headers: {
              'Authorization': 'Bearer ' + this.$cookies.get('bs_token')
            }
          }
        ).then((response) => {
          this.isAdmin = response.data;
        }).catch((error) => {
          console.error("Error checking admin status:", error);
          this.isAdmin = false;
        });
      } catch (error) {
        console.error("Exception in checkSuperAdmin:", error);
        this.isAdmin = false;
      }

      return false;
    },

    async logOut(automatic = false, is_cookie_error = false) {
      const customer_id = this.$cookies.get('bs_customer_id');
      //console.log(automatic, is_cookie_error);
      //return false;
      const login_page = [47, 48].includes(parseInt(customer_id)) ? '/apoteket' : '';

      this.cleanUp().then(val => {
        if (automatic) {
          location.href = this.login_url + login_page + '?redirect=' + location.href;
        }

        // console.log('Logging out, token: ' + this.$cookies.get('bs_token'));
        // return false;
        location.href = this.login_url + login_page + (is_cookie_error ? '?error=cookie' : '');
      });
    },

    async cleanUp() {
      this.cleanup_cookies.forEach(async cookie => {
        // await this.deleteCookie(cookie);

        if (process.env.VUE_APP_ENV === 'production') {
          this.$cookies.remove(cookie, null, process.env.VUE_APP_WRAPPER_COOKIE_DOMAIN);
        } else if (process.env.VUE_APP_ENV === 'development') {
          this.$cookies.remove(cookie, null);
        }
      });

      localStorage.removeItem('active_account');
      localStorage.removeItem('user');
      localStorage.removeItem('notification_popup');

      return true;
    },

    deleteCookie(cookie_name) {
      // console.log('Deleting cookie: ' + cookie_name);
      // document.cookie = cookie_name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      // console.log('Host when deleting cookie: ' + window.location.hostname);

      document.cookie = cookie_name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;Max-Age= -1, path=/;domain=brandsafe.no';
      document.cookie = cookie_name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;Max-Age= -1, path=/;domain=localhost';
    },

    loadPrintBasketSetting() {
      isSettingEnabled(PRINT_BASKET_SETTING).then((enabled) => {
        this.print_basket_enabled = enabled;
        this.fetchPrintBasketCount();
      });
    },

    fetchPrintBasketCount() {
      if (!this.showPrintBasket) return;

      const token = this.$cookies.get('bs_token');
      if (!token) return;

      Axios.get('https://api.brandsafe.no/v2/worklists/print-basket', {
        headers: { 'Authorization': 'Bearer ' + token }
      }).then(response => {
        this.print_basket_count = response.data.data.total_prints || 0;
      }).catch(() => {});
    },

    onPrintBasketEvent(event) {
      this.fetchPrintBasketCount();
    },

    togglePrintBasket() {
      this.show_print_basket = !this.show_print_basket;
    },

    onBasketDrawerUpdated(basket) {
      this.print_basket_count = basket ? basket.total_prints || 0 : 0;
    },

    showMenu() {
      let settings = _.find(this.apps, (app) => {
        return app.hasOwnProperty('route') && app.route === '/settings';
      });

      return (typeof settings !== 'undefined');
    }
  },

  components: {
    AdminAccountSelector,
    AccountSelector,
    NotificationBar,
    HighImportanceNotifications,
    PrintBasketModal
  }
}
</script>

<style lang="less">
.custom-logo {
  height: 35px !important;
  width: auto !important;
  max-width: none !important;
  display: inline !important
}


.header {
  //font-family: 'Cabin', Helvetica, Arial, sans-serif;
  //-webkit-font-smoothing: antialiased;
  //-moz-osx-font-smoothing: grayscale;
  //font-size: 16px;
  //font-weight: 100;
}

.el-dropdown {
  font-size: 16px !important;
  font-weight: 100 !important;
  margin-right: 25px;
}

.activeDepartment {
  background-color: #eaf5d6;
}

.el-popover {
  z-index: 9999999999999999999 !important;
}

.dot {
  height: 10px;
  width: 10px;
  background-color: #909399;
  border-radius: 50%;
  display: inline-block;
}

.el-popover {
  padding: 10px !important;
}

.el-table .info-column {
  background: #909399;
}

.el-table .success-column {
  background: #67C23A;
}

.el-table .warning-column {
  background: #E6A23C;
}

.el-table .error-column {
  background: #F56C6C;
}

.el-menu--horizontal>.el-menu-item {
  height: 60px !important;
  line-height: 60px !important;
}
</style>
